import { Component, OnInit } from '@angular/core';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-todays-unassigned-tickets',
  templateUrl: './todays-unassigned-tickets.component.html',
  styleUrls: ['./todays-unassigned-tickets.component.css']
})
export class TodaysUnassignedTicketsComponent implements OnInit {

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.GetTodaysNewTickets();
  }

  GetTodaysNewTickets = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getTodaysNewTickets()
    .subscribe((data:any)=>{
      this.TicketsList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });
}

}



// WEBPACK FOOTER //
// ./src/app/reports/todays-unassigned-tickets/todays-unassigned-tickets.component.ts